import React from 'react';
import PricingPage from './PricingPage';

// Country-locked pricing page for US Meta Ads — same PricingPage but the
// region context is forced to `us` (USD prices), the currency toggle is
// hidden, and all register CTAs include `?region=us`.
const UsPricingPage = () => <PricingPage lockedRegion="us" />;

export default UsPricingPage;
